import { get } from '@barbanet/api-service'

import { UserMeResponse } from '../types/dto/user'

export const userMeService = () => get<UserMeResponse>('user', 'users/me')
